import React, { useCallback, useRef, useState, useEffect } from "react";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Label,
  Grid,
  Table,
  Icon,
  Button,
  CommentGroup,
  Divider,
  Header,
  GridColumn,
  GridRow,
  Modal,
  Image,
  ModalActions,
  ModalHeader,
  ModalContent,
  Message,
  List,
  Popup,
} from "semantic-ui-react";
import { useFormik } from "formik";
import { Productionform, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { higgs_units, PERIODS } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./ProductionForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import "./ProductionForm.scss";
import { useLanguage } from "../../../../contexts";
import { toast } from "react-toastify";
import { isAdmin, isEditor, isReviewer, isMaster } from "../../../../utils/checkPermission";

const productionFormController = new Productionform();

export function ProductionForm(props) {
  const {
    onClose,
    onReload,
    productionForm,
    production,
    siteSelected,
    period,
    year,
    configFormData,
    unitsRecorded,
  } = props;

  console.log(configFormData, unitsRecorded)
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const { user } = useAuth();

  // Helper function para obtener el customName de un campo
  const getCustomName = (fieldName) => {
    if (configFormData?.fields) {
      const field = configFormData.fields.find(f => f.name === fieldName);
      return field?.customName || null;
    }
    return null;
  };

  const location = useLocation();
  const { productionSelected } = location.state || {};

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!productionSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const [newFiles, setNewFiles] = useState({});
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    onOpenCloseModal();
  };

  
  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved" ? "#d4edda" :
      approvalStatus === "rejected" ? "#f8d7da" :
      approvalStatus === "pending" ? "#fff3cd" : "white",
    color:
      approvalStatus === "approved" ? "#155724" :
      approvalStatus === "rejected" ? "#721c24" :
      approvalStatus === "pending" ? "#856404" : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1
  });

  const formik = useFormik({
    initialValues: initialValues(
      productionForm,
      period,
      year,
      configFormData,
      unitsRecorded
    ),
    
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue, { setSubmitting }) => {
      try {
        if (!productionForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.production) {
            formValue.site = user.production._id;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // } else {
            //   // Desencriptar los datos recibidos
            //   if (!productionForm) {
            //     const productionData = decrypt(productionSelected);
            //     formValue.production = productionData;
            //   }
            // }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }

          await productionFormController.createProductionForm(
            accessToken,
            formValue
          );
          // }
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && productionForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== productionForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: productionForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: productionForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: productionForm._id,
                  documentType: "production",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: productionForm.site?._id || productionForm.site,
                  company: productionForm.company,
                  year: productionForm.year,
                  period: productionForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          console.log("newFiles:", newFiles);
          // Recorrer el JSON
           for (const clave in newFiles) {
             if (newFiles.hasOwnProperty(clave)) {
               console.log(`Uploading files for field: ${clave}`);
               let filesField = await uploadFiles(newFiles[clave]);

               // Combina los archivos nuevos con los existentes
               let finalFilesField = [...formValue[clave].files, ...filesField];
               console.log(`Final files for ${clave}:`, finalFilesField);

               formValue[clave].files = finalFilesField;
             }
           }
          await productionFormController.updateProductionForm(
            accessToken,
            productionForm._id,
            formValue
          );
        }
        onReload();
        if (onClose) {
          onClose();
        } else {
          // Después de guardar exitosamente, navegamos hacia atrás
          goBack();
        }
        setSubmitting(false); // Muy importante para indicar que la acción se ha completado
      } catch (error) {
        console.error(error);
      }
    },
  });

  const uploadFiles = async (filesToUpload, formValue, field) => {
    console.log("uploadFiles called with files:", filesToUpload);
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    if (filesToUpload.length === 0) {
      console.log("No files to upload");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await productionFormController.uploadFileApi(
        accessToken,
        formData
      );
      console.log("Upload response:", response);
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const goBack = () => {
    navigate(`/admin/data/productionforms`, {
      state: { productionSelected: productionSelected },
    });
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await productionFormController.getPeriodsProductionFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
      }
    })();
  }, [formik.values.year]);

  // Determinar los campos únicos y si tienen código
  function findActiveFieldByName(nameToFind) {
    if (configFormData && configFormData.fields) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }
  useEffect(() => {
    (async () => {
      try {
        calculateTotalVPS();
        calculateTotalVFS();
      } catch (error) {
        console.error(error);
      }
    })();
  }, [formik.values]);

  const calculateTotalVPS = () => {
    let sumTotal = 0;
 
    const fields = Array.isArray(configFormData?.fields)
      ? configFormData.fields.filter(
          (item) => item.code.startsWith("VP") && item.code !== "VPS"
        )
      : [
          {
            name: "production_volume",
            standardized_coefficient:
              formik.values?.production_volume?.standardized_coefficient || 1,
          },
        ];

    fields.map((field) => {
      if (formik.values[field.name]) {
        sumTotal +=
          formik.values[field.name].value * [field.standardized_coefficient];
      }
    });

    formik.setFieldValue("standardized_production.value", sumTotal);
    //console.log(sumTotal);
  };

  const calculateTotalVFS = () => {
    let sumTotal = 0;
    const fields = Array.isArray(configFormData?.fields)
      ? configFormData.fields.filter(
          (item) => item.code.startsWith("VF") && item.code !== "VFS"
        )
      : [
          {
            name: "billing_volume",
            standardized_coefficient:
              formik.values?.billing_volume?.standardized_coefficient || 1,
          },
        ];

    fields.map((field) => {
      if (formik.values[field.name]) {
        sumTotal +=
          formik.values[field.name].value * [field.standardized_coefficient];
      }
    });

    formik.setFieldValue("standardized_billing.value", sumTotal);
    //console.log(sumTotal);
  };

  return (
    <Form className="production-form" onSubmit={formik.handleSubmit}>
      {productionForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {productionForm.date ? formatDateView(productionForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {productionForm.creator_user
              ? productionForm.creator_user.lastname
                ? productionForm.creator_user.lastname + " " + productionForm.creator_user.firstname
                : productionForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!productionForm ? (
        <>
          <Grid columns={2} divided>
         <GridRow style={{ display: "flex", gap: "20px" }}>
                    {/* Año */}
                    <GridColumn 
                    style={{ flex: 1 }}
                    >
                      <div
                       // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                      >
                        <div
                          //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                        >
                         <label style={{ minWidth: "80px", fontWeight: 600 }}>
  <span style={{ color: "red" }}>*</span> {t("year")}
</label>

                          <Form.Dropdown
                            placeholder={t("select")}
                            options={years.map((year) => ({
                              key: year,
                              text: year,
                              value: year,
                            }))}
                            selection
                            onChange={(_, data) =>
                              formik.setFieldValue("year", data.value)
                            }
                            value={formik.values.year}
                            error={!!formik.errors.year && !!formik.touched.year}
                            style={{ flex: 1 }}
                          />
                        </div>
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8em",
                            minHeight: "1.2em",
                          }}
                        >
                          {formik.touched.year && formik.errors.year}
                        </div>
                      </div>
                    </GridColumn>
        
                    {/* Periodo */}
                    <GridColumn
                     style={{ flex: 1 }}>
                      <div
                       // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                      >
                        <div
                          //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                        >
                          <label style={{ minWidth: "80px", fontWeight: 600 }}>
                            <span style={{ color: "red" }}>*</span> {t("period")}
</label>
                   
                          <Form.Dropdown
                            placeholder={t("select")}
                            options={listPeriods.map((period) => ({
                              key: period,
                              text: t(period),
                              value: period,
                            }))}
                            selection
                            disabled={yearComplete}
                            value={formik.values.period}
                            onChange={(_, data) => {
                              // Actualiza el valor
                              formik.setFieldValue("period", data.value);
                              // Marca el campo como tocado (opcional)
                              formik.setFieldTouched("period", true, false);
                              // Borra el error si hay uno
                              formik.setFieldError("period", undefined);
                            }}
                            error={!!formik.errors.period && !!formik.touched.period}
                            style={{ flex: 1 }}
                          />
                        </div>
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8em",
                            minHeight: "1.2em",
                          }}
                        >
                          {formik.touched.period && formik.errors.period}
                        </div>
                      </div>
                    </GridColumn>
                  </GridRow></Grid>
          {yearComplete && !productionForm && (
            <div style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
              maxWidth: "800px",
              zIndex: 99999,
              backgroundColor: "#fffef5",
              border: "1px solid #e8e8e8",
              borderRadius: "6px",
              padding: "15px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              textAlign: "center"
            }}>
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      {canEditUnits && productionForm && (
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            type="button"
            color={unitEditEnabled ? "orange" : "grey"}
            size="small"
            icon
            labelPosition="left"
            onClick={() => setUnitEditEnabled(!unitEditEnabled)}
          >
            <Icon name={unitEditEnabled ? "unlock" : "lock"} />
            {unitEditEnabled
              ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
              : (t("enable_unit_edit") || "Habilitar edición de unidades")
            }
          </Button>
          {unitEditEnabled && (
            <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
              <Icon name="warning sign" />
              {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
            </Message>
          )}
        </div>
      )}
      <div className="production-form-table-wrapper">
      <Table className="production-form-table" unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="1"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("code")}</Table.HeaderCell>
            <Table.HeaderCell width="4"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("concept")}</Table.HeaderCell>
            <Table.HeaderCell width="2"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("standardized_coefficient")}
            </Table.HeaderCell>
            <Table.HeaderCell width="2"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("value")}</Table.HeaderCell>
            <Table.HeaderCell width="2"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("unit")}</Table.HeaderCell>
            <Table.HeaderCell width="2"
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("state")}</Table.HeaderCell>
            <Table.HeaderCell width={2} 
             style={{ fontWeight: "bold", textAlign: "center" }}
            >{t("actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row className="production-form-section-header">
            <Table.Cell colSpan="7">Volumen</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <label className="label">
                {formik.values.production_volume.code}{" "}
              </label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">{getCustomName("production_volume") || t("production_volume")}</label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">
                {formik.values.production_volume.standardized_coefficient}
              </label>
            </Table.Cell>
            <Table.Cell>
              <Form.Input
                type="number"
                name="production_volume.value"
                onChange={formik.handleChange}
                value={formik.values.production_volume.value}
                error={
                  formik.errors.production_volume?.value
                    ? formik.errors.production_volume.value
                    : null
                }
              />
            </Table.Cell>

            <Table.Cell>
               <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.production_volume?.unit &&
                    formik.touched.production_volume?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.production_volume.unit}
                      </div>
                    )}
              <Form.Dropdown
                //placeholder="Celda datos fijos"
                options={higgs_units.map((ds) => {
                  return {
                    key: ds.key,
                    text: ds.name,
                    value: ds.value,
                  };
                })}
                selection
                disabled={!unitEditEnabled}
                onChange={(_, data) =>{
                  formik.setFieldValue("production_volume.unit", data.value);
                  formik.setFieldTouched(
                        "production_volume.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "production_volume.unit",
                          undefined
                        );
                      }
                }
              
              }
                value={formik.values.production_volume.unit}
                error={
                      !!formik.errors.production_volume?.unit &&
                      !!formik.touched.production_volume?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.production_volume?.unit &&
                        formik.touched.production_volume?.unit
                          ? "red"
                          : undefined,
                    }}
              /></div>
            </Table.Cell>

            <Table.Cell>
              <Form.Dropdown
                placeholder={t("select")}
                options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                selection
                disabled={isEditor(user.role) && !isMaster(user.role)}
                onChange={(_, data) =>
                  formik.setFieldValue(
                    "production_volume.approvalStatus",
                    data.value
                  )
                }
                value={formik.values.production_volume.approvalStatus}
                error={
                  formik.errors.production_volume?.approvalStatus
                    ? formik.errors.production_volume.approvalStatus
                    : null
                }
                style={getApprovalStatusStyle(formik.values.production_volume.approvalStatus, isEditor(user.role))}
              />
            </Table.Cell>
            <Table.Cell>
          

               <Popup
                                content={t("add_comment")}
                                trigger={
                               <Button
                icon
                size="small"
                color="teal"  type="button"
                onClick={() => {
                  openUpdateSite(t("production_volume"), "production_volume");
                }}
              >
                <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
              </Button>
                                }
                              />
              <FileUpload
                accessToken={accessToken}
                data={formik}
                field={"production_volume"}
                newFiles={newFiles}
                setNewFiles={setNewFiles}
                t={t}
              />
            </Table.Cell>
          </Table.Row>
          {configFormData && configFormData.fields
            ? configFormData.fields
                .filter(
                  (field) =>
                    field.code.startsWith("VP") &&
                    field.code !== "VPS" &&
                    field.code !== "VP1"
                )
                .map((result) => (
                  <>
                    <Table.Row>
                      <Table.Cell>
                        <label className="label">
                          {formik.values[result.name].code}{" "}
                        </label>
                      </Table.Cell>
                      <Table.Cell>
                        <label className="label">{result.customName || t([result.name])}</label>
                      </Table.Cell>
                      <Table.Cell>
                        <label className="label">
                          {formik.values[result.name].standardized_coefficient}
                        </label>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Input
                          type="number"
                          name={[result.name] + ".value"}
                          onChange={formik.handleChange}
                          value={formik.values[result.name].value}
                          error={
                            formik.errors[result.name]
                              ? formik.errors[result.name]
                              : null
                          }
                        />
                      </Table.Cell>

                      <Table.Cell>
                         <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors[result.name]?.unit &&
                    formik.touched[result.name]?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors[result.name].unit}
                      </div>
                    )}
                        <Form.Dropdown
                          //placeholder="Celda datos fijos"
                          options={higgs_units.map((ds) => {
                            return {
                              key: ds.key,
                              text: ds.name,
                              value: ds.value,
                            };
                          })}
                          selection
                          disabled={!unitEditEnabled}
                          onChange={(_, data) =>{
                            formik.setFieldValue(
                              [result.name] + ".unit",
                              data.value
                            );
                            formik.setFieldTouched(
                         [result.name] + ".unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                           [result.name] + ".unit",
                          undefined
                        );
                      }
                          }}
                          value={formik.values[result.name].unit}
                          error={
                      !!formik.errors[result.name]?.unit &&
                      !!formik.touched[result.name]?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors[result.name]?.unit &&
                        formik.touched[result.name]?.unit
                          ? "red"
                          : undefined,
                    }}
                        /> </div>
                      </Table.Cell>

                      <Table.Cell>
                        <Form.Dropdown
                          placeholder={t("select")}
                          options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                          selection
                          disabled={isEditor(user.role) && !isMaster(user.role)}
                          onChange={(_, data) =>
                            formik.setFieldValue(
                              [result.name] + ".approvalStatus",
                              data.value
                            )
                          }
                          value={formik.values[result.name].approvalStatus}
                          error={
                            formik.errors[result.name]?.approvalStatus
                              ? formik.errors[result.name].approvalStatus
                              : null
                          }
                          style={getApprovalStatusStyle(formik.values[result.name].approvalStatus, isEditor(user.role))}
                        />
                      </Table.Cell>
                      <Table.Cell>
                           <Popup
                                content={t("add_comment")}
                                trigger={
                             <Button
                          icon
                          color="teal"  type="button"
                          onClick={() => {
                            openUpdateSite(t(result.name), result.name);
                          }}
                        >
                          <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                        </Button>
                                }
                              />
            
                        <FileUpload
                          accessToken={accessToken}
                          data={formik}
                          field={result.name}
                          newFiles={newFiles}
                          setNewFiles={setNewFiles}
                          t={t}
                        />
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))
            : null}


           {/*<Table.Row>
           //comentamos a pedido del cliente momentanemaente se volvera a activar a futuro
            <Table.Cell>
              <label className="label">
                {formik.values.standardized_production.code}{" "}
              </label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">{t("standardized_production")}</label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">
                {formik.values.standardized_production.standardized_coefficient}
              </label>
            </Table.Cell>
            <Table.Cell>
              <Form.Input
                type="number"
                name="standardized_production.value"
                // onChange={formik.handleChange}
                value={formik.values.standardized_production.value}
                error={formik.errors.standardized_production}
              />
            </Table.Cell>
            <Table.Cell>
                  <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  //Error en header 
                  {formik.errors.standardized_production?.unit &&
                    formik.touched.standardized_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.standardized_production.unit}
                      </div>
                    )}
              <Form.Dropdown
                //placeholder="Celda datos fijos"
                options={higgs_units.map((ds) => {
                  return {
                    key: ds.key,
                    text: ds.name,
                    value: ds.value,
                  };
                })}
                selection
                disabled={!unitEditEnabled}
                onChange={(_, data) =>{
                  formik.setFieldValue(
                    "standardized_production.unit",
                    data.value
                  );
                   formik.setFieldTouched(
                        "standardized_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "standardized_production.unit",
                          undefined
                        );
                      }
                }
                }
                value={formik.values.standardized_production.unit}
                  error={
                      !!formik.errors.standardized_production?.unit &&
                      !!formik.touched.standardized_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.standardized_production?.unit &&
                        formik.touched.standardized_production?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
            </Table.Cell>
            <Table.Cell>
              <Form.Dropdown
                placeholder={t("select")}
                options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                selection
                disabled={isEditor(user.role) && !isMaster(user.role)}
                onChange={(_, data) =>
                  formik.setFieldValue(
                    "standardized_production.approvalStatus",
                    data.value
                  )
                }
                value={formik.values.standardized_production.approvalStatus}
                error={formik.errors.standardized_production}
                style={getApprovalStatusStyle(formik.values.standardized_production.approvalStatus, isEditor(user.role))}
              />
            </Table.Cell>

            <Table.Cell>
         
                         <Popup
                                content={t("add_comment")}
                                trigger={
                                        <Button
                icon
                size="small"
                color="teal"  type="button"
                onClick={() => {
                  openUpdateSite(
                    t("standardized_production"),
                    "standardized_production"
                  );
                }}
              >
                <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
              </Button>
                                }
                              />
              <FileUpload
                accessToken={accessToken}
                data={formik}
                field={"standardized_production"}
                newFiles={newFiles}
                setNewFiles={setNewFiles}
                t={t}
              />
            </Table.Cell>

          </Table.Row>*/}
          <Table.Row className="production-form-section-header">
            <Table.Cell colSpan="7">Facturación</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <label className="label">
                {formik.values.billing_volume.code}{" "}
              </label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">{getCustomName("billing_volume") || t("billing_volume")}</label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">
                {formik.values.billing_volume.standardized_coefficient}
              </label>
            </Table.Cell>
            <Table.Cell>
              <Form.Input
                type="number"
                name="billing_volume.value"
                onChange={formik.handleChange}
                value={formik.values.billing_volume.value}
                error={
                  formik.errors.billing_volume?.value
                    ? formik.errors.billing_volume.value
                    : null
                }
              />
            </Table.Cell>

            <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.billing_volume?.unit &&
                    formik.touched.billing_volume?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.billing_volume.unit}
                      </div>
                    )}
              <Form.Dropdown
                //placeholder="Celda datos fijos"
                options={higgs_units.map((ds) => {
                  return {
                    key: ds.key,
                    text: ds.name,
                    value: ds.value,
                  };
                })}
                selection
                disabled={!unitEditEnabled}
                onChange={(_, data) =>{
                  formik.setFieldValue("billing_volume.unit", data.value);
                  formik.setFieldTouched(
                        "billing_volume.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "billing_volume.unit",
                          undefined
                        );
                      }
                }
                }
                value={formik.values.billing_volume.unit}
                 error={
                      !!formik.errors.billing_volume?.unit &&
                      !!formik.touched.billing_volume?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.billing_volume?.unit &&
                        formik.touched.billing_volume?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
            </Table.Cell>

            <Table.Cell>
              <Form.Dropdown
                placeholder={t("select")}
                options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                selection
                disabled={isEditor(user.role) && !isMaster(user.role)}
                onChange={(_, data) =>
                  formik.setFieldValue("billing_volume.approvalStatus", data.value)
                }
                value={formik.values.billing_volume.approvalStatus}
                error={
                  formik.errors.billing_volume?.approvalStatus
                    ? formik.errors.billing_volume.approvalStatus
                    : null
                }
                style={getApprovalStatusStyle(formik.values.billing_volume.approvalStatus, isEditor(user.role))}
              />
            </Table.Cell>
            <Table.Cell>
              <Popup
                                content={t("add_comment")}
                                trigger={
                                   <Button
                icon
                size="small"
                color="teal"  type="button"
                onClick={() => {
                  openUpdateSite(t("billing_volume"), "billing_volume");
                }}
              >
                <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
              </Button>
                                }
                              />
            
              <FileUpload
                accessToken={accessToken}
                data={formik}
                field={"billing_volume"}
                newFiles={newFiles}
                setNewFiles={setNewFiles}
                t={t}
              />
            </Table.Cell>
          </Table.Row>
          {configFormData && configFormData.fields
            ? configFormData.fields
                .filter(
                  (field) =>
                    field.code.startsWith("VF") &&
                    field.code !== "VFS" &&
                    field.code !== "VF1"
                )
                .map((result) => (
                  <>
                    <Table.Row>
                      <Table.Cell>
                        <label className="label">
                          {formik.values[result.name].code}{" "}
                        </label>
                      </Table.Cell>
                      <Table.Cell>
                        <label className="label">{result.customName || t([result.name])}</label>
                      </Table.Cell>
                      <Table.Cell>
                        <label className="label">
                          {formik.values[result.name].standardized_coefficient}
                        </label>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Input
                          type="number"
                          name={[result.name] + ".value"}
                          onChange={formik.handleChange}
                          value={formik.values[result.name].value}
                          error={
                            formik.errors[result.name]?.value
                              ? formik.errors[result.name].value
                              : null
                          }
                        />
                      </Table.Cell>

                      <Table.Cell>
                              <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors[result.name]?.unit &&
                    formik.touched[result.name]?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors[result.name].unit}
                      </div>
                    )}
                        <Form.Dropdown
                          //placeholder="Celda datos fijos"
                          options={higgs_units.map((ds) => {
                            return {
                              key: ds.key,
                              text: ds.name,
                              value: ds.value,
                            };
                          })}
                          selection
                          disabled={!unitEditEnabled}
                          onChange={(_, data) =>{
                            formik.setFieldValue(
                              [result.name] + ".unit",
                              data.value
                            );

                               formik.setFieldTouched(
                          [result.name] + ".unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                            [result.name] + ".unit",
                          undefined
                        );
                      }
                          }
                          }
                          value={formik.values[result.name].unit}
                        error={
                      !!formik.errors[result.name]?.unit &&
                      !!formik.touched[result.name]?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors[result.name]?.unit &&
                        formik.touched[result.name]?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
                      </Table.Cell>

                      <Table.Cell>
                        <Form.Dropdown
                          placeholder={t("select")}
                          options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                          selection
                          disabled={isEditor(user.role) && !isMaster(user.role)}
                          onChange={(_, data) =>
                            formik.setFieldValue(
                              [result.name] + ".approvalStatus",
                              data.value
                            )
                          }
                          value={formik.values[result.name].approvalStatus}
                          error={
                            formik.errors[result.name]?.approvalStatus
                              ? formik.errors[result.name].approvalStatus
                              : null
                          }
                          style={getApprovalStatusStyle(formik.values[result.name].approvalStatus, isEditor(user.role))}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Popup
                  content={t("add_comment")}
                  trigger={
                     <Button
                          icon
                          color="teal"  type="button"
                          onClick={() => {
                            openUpdateSite(t(result.name), result.name);
                          }}
                        >
                          <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                        </Button>
                  }
                />
                       
                        <FileUpload
                          accessToken={accessToken}
                          data={formik}
                          field={result.name}
                          newFiles={newFiles}
                          setNewFiles={setNewFiles}
                          t={t}
                        />
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))
            : null}

{/* Comentamos a pedido del cliente momentaneamente se volvera a activar a futuro
          <Table.Row>
            <Table.Cell>
              <label className="label">
                {formik.values.standardized_billing.code}{" "}
              </label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">{t("standardized_billing")}</label>
            </Table.Cell>
            <Table.Cell>
              <label className="label">
                {formik.values.standardized_billing.standardized_coefficient}
              </label>
            </Table.Cell>
            <Table.Cell>
              <Form.Input
                type="number"
                name="standardized_billing.value"
                // onChange={formik.handleChange}
                value={formik.values.standardized_billing.value}
                error={formik.errors.standardized_billing}
              />
            </Table.Cell>
            <Table.Cell>
               <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  //Error en header 
                  {formik.errors.standardized_billing?.unit &&
                    formik.touched.standardized_billing?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.standardized_billing.unit}
                      </div>
                    )}
              <Form.Dropdown
                //placeholder="Celda datos fijos"
                options={higgs_units.map((ds) => {
                  return {
                    key: ds.key,
                    text: ds.name,
                    value: ds.value,
                  };
                })}
                selection
                disabled={!unitEditEnabled}
                onChange={(_, data) =>{
                  formik.setFieldValue("standardized_billing.unit", data.value);
                  formik.setFieldTouched(
                        "standardized_billing.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "standardized_billing.unit",
                          undefined
                        );
                      }
                }
                }
                value={formik.values.standardized_billing.unit}
                error={formik.errors.standardized_billing}
              />
              </div>
            </Table.Cell>
            <Table.Cell>
              <Form.Dropdown
                placeholder={t("select")}
                options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                selection
                disabled={isEditor(user.role) && !isMaster(user.role)}
                onChange={(_, data) =>
                  formik.setFieldValue(
                    "standardized_billing.approvalStatus",
                    data.value
                  )
                }
                value={formik.values.standardized_billing.approvalStatus}
                error={formik.errors.standardized_billing}
                style={getApprovalStatusStyle(formik.values.standardized_billing.approvalStatus, isEditor(user.role))}
              />
            </Table.Cell>

            <Table.Cell>
              <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                icon
                size="small"
                color="teal"  type="button"
                onClick={() => {
                  openUpdateSite(
                    t("standardized_billing"),
                    "standardized_billing"
                  );
                }}
              >
                <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
              </Button>
                  }
                />
              
              <FileUpload
                accessToken={accessToken}
                data={formik}
                field={"standardized_billing"}
                newFiles={newFiles}
                setNewFiles={setNewFiles}
                t={t}
              />
            </Table.Cell>
          </Table.Row>*/}
        </Table.Body>
      </Table>
      </div>

          <BasicModal
                     show={showModal}
                     onClose={() => setShowModal(false)}       // cerrar desde aquí
                     title={titleModal}
                     size="tiny"
                     closeOnDimmerClick={false}             // evita cierre al hacer clic fuera
                     closeOnEscape={false}                   // opcional
                   >
                     
                     <div onClick={(e) => e.stopPropagation()}>
        <Comments
          formik={formik}
          fieldName={fieldName}
          onClose={() => setShowModal(false)}
          onReload={onReload}
          productionForm={productionForm}
          user={user}
          t={t}
        /></div>
      </BasicModal>
       <div
              style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem",marginRight:20, marginTop:20 }}
            >
              <Form.Button
                type="submit"
                primary
                size="large"
                loading={formik.isSubmitting}
            //             labelPosition="right"
            // icon="checkmark"
             content=  {!productionForm ? t("save") : t("update")}
              >
              
              </Form.Button>
      
              <Form.Button
                type="button"
                color="red"
                secondary
                size="large"
                onClick={() => {
                  onClose ? onClose() : goBack();
                }}
                
              >
                {t("cancel")}
              </Form.Button>
            </div>
    </Form>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
    
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted />    {console.log(review)}
        </React.Fragment>
      ))}

      <Form reply className="production-comments-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div style={{ display: "flex", gap: "0.75em", marginTop: "1em", justifyContent: "center" }}>
          <Button
            type="button"
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button"
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
const EditableComment = ({ id, author, date, content, onSave, active, t }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleSave = () => { onSave(id, editedContent); setIsEditing(false); };
  const handleCancel = () => { setEditedContent(content); setIsEditing(false); };

  const initials = author
    ? author.split(" ").filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join("")
    : "?";

  return (
    <div className="ec-comment-row">
      <div className="ec-avatar">{initials}</div>
      <div className="ec-body">
        <span className="ec-date">{date}</span>
        {isEditing ? (
          <>
            <textarea
              className="ec-edit-input"
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
            />
            <div className="ec-edit-actions">
              <Button size="mini" primary onClick={handleSave} content={t("save")} />
              <Button size="mini" secondary onClick={handleCancel} content={t("cancel")} />
            </div>
          </>
        ) : (
          <div className="ec-content">{editedContent}</div>
        )}
      </div>
      {active && !isEditing && (
        <button className="ec-edit-btn" onClick={() => setIsEditing(true)}>
          <Icon name="pencil alternate" />
        </button>
      )}
    </div>
  );
};

function FileViewer(props) {
  const { fileName, fileUniqueName, file, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileUniqueName) {
      const url = productionFormController.getFileApi(fileUniqueName);
      setFileUrl(url);
    } else if (file) {
      const url = URL.createObjectURL(file);
      setFileUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [fileName, fileUniqueName, file]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      {fileUniqueName && (
        <List.Content floated="right">
          <Button
            color="red"
            onClick={() => handleRemove(fileUniqueName)}
            icon="trash alternate"
          />
        </List.Content>
      )}
      {!fileUniqueName && (
        <List.Content floated="right">
          <Button
            color="orange"
            onClick={handleRemove}
            icon="remove"
          />
        </List.Content>
      )}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    console.log(`FilesView for ${field}:`, data.values[field].files);
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    console.log(`Files selected for ${field}:`, selectedFiles);
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
    setPendingFiles(Array.from(selectedFiles));
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (fileUniqueName) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== fileUniqueName);
      setFilesView(updatedFiles);
      const response = await productionFormController.deleteFileApi(
        accessToken,
        fileUniqueName
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removePendingFile = (file) => {
    setPendingFiles(pendingFiles.filter(f => f !== file));
    setNewFiles({ ...newFiles, [field]: newFiles[field].filter(f => f !== file) });
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

       <Popup
              content={t("upload_file")}
              trigger={
                <Button
                  default
                  onClick={handleButtonClick}
                  style={{ marginTop: "10px" }}
                  color={files.length > 0 ? "green" : "grey"}
                >
                  <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
                </Button>
              }
            />

      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

     <Popup
             content={t("view_file")}
             trigger={
               <Button
                 primary
                 onClick={closeModal}
                 style={{ marginTop: "10px" }}
               >
                 <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
               </Button>
             }
           />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          {(filesView.length > 0 || pendingFiles.length > 0) ? (
            <List divided>
              {filesView.map((filePath, index) => (
                <List.Item key={`uploaded-${index}`}>
                  <FileViewer
                    fileName={filePath.name}
                    fileUniqueName={filePath.uniqueName}
                    handleRemove={handleRemoveFile}
                    t={t}
                  />
                </List.Item>
              ))}
              {pendingFiles.map((file, index) => (
                <List.Item key={`pending-${index}`}>
                  <FileViewer
                    fileName={file.name}
                    file={file}
                    handleRemove={() => removePendingFile(file)}
                    t={t}
                  />
                </List.Item>
              ))}
            </List>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5em",
                color: "#9e9e9e",
                padding: "2em 0",
              }}
            >
              <Icon name="file outline" size="big" />
              <span>No se encontraron archivos subidos.</span>
            </div>
          )}
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
